import { DriveStep } from 'driver.js';
import type { TFunction } from 'i18next';

export const createSpeechTourSteps = (t: TFunction): DriveStep[] => [
  {
    element: '[data-tour="speech-slide-0"]',
    popover: {
      title: t('onboarding.speech.slide_title', 'Текст выступления'),
      description: t(
        'onboarding.speech.slide_desc',
        'Сгенерированный текст для каждого слайда. Можно редактировать под свой стиль.',
      ),
    },
  },
  {
    element: '[data-tour="speech-edit-0"]',
    popover: {
      title: t('onboarding.speech.edit_title', 'Редактирование'),
      description: t(
        'onboarding.speech.edit_desc',
        'Нажмите карандаш, чтобы изменить текст слайда.',
      ),
    },
  },
  {
    element: '[data-tour="speech-bullets-0"]',
    popover: {
      title: t('onboarding.speech.bullets_title', 'Тезисы'),
      description: t(
        'onboarding.speech.bullets_desc',
        'Краткие подсказки для спикера — видны во время тренировки.',
      ),
    },
  },
  {
    element: '[data-tour="speech-start-practice"]',
    popover: {
      title: t('onboarding.speech.practice_title', 'Начать тренировку'),
      description: t(
        'onboarding.speech.practice_desc',
        'Когда текст готов — записывайте выступление с анализом речи.',
      ),
    },
  },
];
